import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../state";
import { euroFormat, quantityFormat } from "../../utils";
import Popup from "../Popup";
import { DexxNumericInput } from "../utils/Input";
import PopupLabelAndValue from "./utils/PopupLabelAndValue";
import GenericPopup from "./GenericPopup";
import PopupRowData from "./utils/PopupRowData";
import PopupDivider from "./utils/PopupDivider";

export default function LiquidationPopup(props: {
    tokensSold: number, price: number, uuid: string, setLiquidationPriceRequest: Function
    closeFunction: Function
}): JSX.Element {

    const [liquidationPrice, setLiquidationPrice] = useState<number>(0)
    const [totalAmount, setTotalAmount] = useState<number>(0)
    const [showPopUp, setShowPopUp] = useState<boolean>(false)
    const [showConfirmPopUp, setConfirmShowPopUp] = useState<boolean>(false)
    const [titlePopUp, setTitlePopUp] = useState<string>("")
    const [msgPopUp, setMsgPopUp] = useState<string>("")
    const minLiquidationPrice = 0
    const [balance, setBalance] = useState<any>()

    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)

    function handleLiquidation() {
        if (liquidationPrice) {
            let price = parseFloat((liquidationPrice + "").replace(",", "."))
            if (price <= minLiquidationPrice) {
                setShowPopUp(true)
                setTitlePopUp("Sorry!")
                setMsgPopUp("Please increase your liquidation price (" + liquidationPrice + "). " +
                    "The price must be greater than the minimum price allowed (" + minLiquidationPrice + ").")
            } else if (balancePT < totalAmount) {
                setShowPopUp(true)
                setTitlePopUp("Sorry!")
                setMsgPopUp("Insufficient funds available to complete the liquidation. Please deposit additional funds to your wallet.")
            } else {
                setConfirmShowPopUp(true)
            }
        }
    }

    useEffect(() => {
        actions.getIssuerBalance(setBalance)
    }, [])

    useEffect(() => {
        setTotalAmount(liquidationPrice ? parseFloat(liquidationPrice.toString().replace(",", ".")) * props.tokensSold : 0)
    }, [liquidationPrice])

    let balancePT = balance?.payment_tokens?.available_total

    return <>
        <Popup show={showPopUp} title={titlePopUp} msg={msgPopUp} btnOk={true} close={() => { setShowPopUp(false) }} />
        <Popup show={showConfirmPopUp} title={"Confirm your action"}
            msg={<div>Are you sure you would like to liquidate this Token? This cannot be undone.<br />Price: {liquidationPrice}</div>} btnOk={true} btnConfirm={true}
            close={() => { setConfirmShowPopUp(false) }} handleConfirm={() => {
                actions.sendLiquidationPrice({
                    token_uuid: props.uuid,
                    price: liquidationPrice ? parseFloat((liquidationPrice + "").replace(",", ".")) : 0
                },
                    props.setLiquidationPriceRequest); setConfirmShowPopUp(false)
            }}></Popup>
        <GenericPopup closeFunction={props.closeFunction} handleSubmit={handleLiquidation}>
            <PopupRowData nColumns="1">
                <div className="uppercase text-succ1 text-base font-medium">
                    FIMART euro voucher</div>
                <div className="text-primary text-xl font-normal">
                    {euroFormat(balancePT) + "€"}</div>
            </PopupRowData>
            <PopupDivider color="succ1" />
            <PopupRowData nColumns="1">
                <PopupLabelAndValue label={"Asset Liquidation"} value="
                    As an issuer you can execute this Liquidation action to remove an asset from the market. 
                    You define the liquidation price and visualize the total balance you need to liquidate the offer. 
                    All the tokens will be burn and investors will receive in return Fimart Euro Vouchers proportional 
                    to the amount of tokens he/she has.
                "/>
            </PopupRowData>
            <PopupDivider color="succ1" />
            <PopupRowData nColumns="2" className="mb-2">
                <PopupLabelAndValue label={"Tokens sold:"}
                    value={quantityFormat(props.tokensSold)} />
                <PopupLabelAndValue label={"Price:"}
                    value={euroFormat(props.price) + "€"} />
                <PopupLabelAndValue label={"Liquidation price *:"} value={
                    <DexxNumericInput value={liquidationPrice} fun={setLiquidationPrice} />} />
                <PopupLabelAndValue label={"Total amount:"} value={
                    euroFormat(totalAmount) + "€"} />
            </PopupRowData>
        </GenericPopup>
    </>
}